import React from 'react'
import "./navbar.css"
const Navbar = () => {
  return (
    <>
        <nav className="main-nav"> 
                    {/* 1st Geekster Logo */}
            <div className="logo"><img src="https://geekster.in/images/logo.svg" alt="Geekster Logo"></img></div>
                    {/* 2nd Geekster Menus */}
            <div className="menu-link">
                <ul>
                    <li><a href="https://geekster.in/" className='home'><span>Home</span></a></li>
                    <li>
                    <div className="courses">
                    <a href="https://geekster.in/" className="courses-btn">Courses</a>
                    <span><img src="https://geekster.in/icons/down-arrow.svg" alt='arrow'></img></span>
                    <div className="dropdown-content">
                        <a href="https://geekster.in/">Full Stack Web Development</a>
                        <a href="https://geekster.in/">Career Kickstarter</a>
                    </div>
                    </div>
                    </li>
                    <li><a href="https://geekster.in/" className='hire-t'>Hire Talent</a></li>
                    <li><a href="https://geekster.in/" className='blog'>Blog</a></li>
                    <li><a href="https://geekster.in/" className='isa'>ISA</a></li>
                </ul>
            </div> 
                {/* 3rd Request Call Back Button */}
            <div className="request-call">
                <a href="tel:+917067549967"><button>Request Call Back</button></a>
            </div>
        </nav>    
    </>
  )
}

export default Navbar